// Images are served through Thumbor: {host}/fit-in/{width}x{height}/{fileName}
const imageUrl = (fileName, size = '930x540') =>
  fileName ? `${process.env.REACT_APP_IMAGES_FILE_HOST}/fit-in/${size}/${fileName}` : '';

export default imageUrl;
